import {
  TESTIMONIAL_VARIANTS,
  T_02 as TESTIMONIAL_T02,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const TESTIMONIAL_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: TESTIMONIAL_VARIANTS,
    defaultValue: TESTIMONIAL_T02,
    description: "Select testimonial variant",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
